import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #TOOLTIP
\*------------------------------------ */
:host {
  white-space: normal;
}

[popover] {
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
}

/**
 * 1) An icon that appears
 */
.cat-c-tooltip {
  display: inline-block;
  position: relative;
  max-width: 100%;
  width: var(--cat-tooltip-width);
  /**
   * Focus treatment only when triggered with a keyboard
   */
}
.cat-c-tooltip:focus-visible {
  outline: var(--cat-theme-color-border-brand) solid var(--cat-theme-border-width);
  outline-offset: 2px;
}

/**
 * Tooltip content container
 */
.cat-c-tooltip__content {
  display: none;
  text-align: start;
  overflow: visible;
  max-width: var(--cat-tooltip-max-width, 255px);
  width: var(--cat-tooltip-width, max-content);
  z-index: var(--cat-z-index-top);
  background-color: var(--cat-theme-color-background-default);
  border-radius: var(--cat-border-radius-lg);
  color: var(--cat-theme-color-content-strong);
  box-shadow: var(--cat-theme-box-shadow-md);
  margin-block-end: var(--cat-space-2x-small);
  --arrow-size: 15px;
  word-wrap: break-word;
}
.cat-c-tooltip--text-align-right .cat-c-tooltip__content {
  text-align: end;
}

/**
 * Tooltip inner text
 */
.cat-c-tooltip__text {
  display: block;
  background-color: var(--cat-theme-color-background-default);
  border-radius: var(--cat-border-radius-lg);
  padding: var(--cat-space-x-small);
  position: relative;
  z-index: var(--cat-z-index-top);
}

/**
 * Tooltip arrow 
 */
.cat-c-tooltip__arrow {
  position: absolute;
  transform: rotate(45deg);
  width: var(--arrow-size);
  height: var(--arrow-size);
  background-color: var(--cat-theme-color-background-default);
  box-shadow: var(--cat-theme-box-shadow-md);
}
`;
       